import React, { useEffect } from "react";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BiCheckCircle } from "react-icons/bi";
import { TiDeleteOutline } from "react-icons/ti";
import { useDispatch } from "react-redux";
import { deleteAllFromCart } from "../../store/slices/cart-slice";

export default function OrderStatus() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const dispatch = useDispatch();

  const orderId = params.get("order");
  const isSuccess = params.get("success") === "true";
  const amountCents = params.get("amount_cents");
  const currency =
    params.get("currency") || import.meta.env.VITE_REACT_APP_CURRENCY_EN;
  const message = params.get("data.message");
  const createdAt = params.get("created_at");
  const method = params.get("method");

  useEffect(() => {
    if (isSuccess) {
      dispatch(deleteAllFromCart());
    }
  }, [isSuccess]);

  return (
    <>
      <SEO titleTemplate="orders" />

      <LayoutOne headerTop="visible">
        <div className="container my-5 d-flex justify-content-center order-status p-0">
          {method == "cash" ? (
            <div className="card w-fit p-4">
              <div className="first d-flex justify-content-center align-items-center mb-3">
                {isSuccess ? (
                  <BiCheckCircle className="text-success" size={50} />
                ) : (
                  <TiDeleteOutline className="text-danger" size={50} />
                )}
              </div>

              <div className="detail d-flex justify-content-center">
                <span
                  className="d-block summery text-center w-75"
                  style={{
                    lineClamp: 2,
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                  }}
                >
                  {isSuccess
                    ? t("order_success_msg_cash")
                    : `${t("order_failed_msg_cash")}`}
                </span>
              </div>

              <button
                className="btn btn-dark mt-4"
                onClick={() => (window.location.href = "/")}
              >
                {t("back_to_home")}
              </button>
            </div>
          ) : (
            <div className="card w-75 p-4">
              <div className="first d-flex justify-content-between align-items-center mb-3">
                <div className="info">
                  <span className="d-block name mb-2">
                    {isSuccess ? t("thank_you") : t("payment_failed")}
                  </span>
                  <span className="order">
                    {" "}
                    {t("order_number")} - {orderId}
                  </span>
                </div>
                <img
                  src={
                    isSuccess
                      ? "https://i.imgur.com/NiAVkEw.png"
                      : "https://i.imgur.com/oCkEbrA.png"
                  }
                  width={40}
                />
              </div>

              <div className="detail">
                <span className="d-block summery">
                  {isSuccess
                    ? t("order_success_msg")
                    : `${t("order_failed_msg")} ${
                        message || t("card_unavailable")
                      }`}
                </span>
              </div>

              <hr />

              <div className="mt-3">
                <strong>{t("amount")}:</strong> {(amountCents / 100).toFixed(2)}{" "}
                {currency}
              </div>
              <div>
                <strong>{t("date")}:</strong>{" "}
                {createdAt ? new Date(createdAt).toLocaleString() : "N/A"}
              </div>
            </div>
          )}
        </div>
      </LayoutOne>
    </>
  );
}
